// utils/HTMLReportGenerator/ReportFilters.js

export class ReportFilters {
  /**
   * Générer la section des filtres
   */
  static generateFiltersSection(filterStats) {
    return `
        <div class="filters-section">
          <div class="filters-header">Filtres</div>
          <div class="filters-content">
            <div class="filter-group">
              <div class="filter-title">Statut</div>
              <div class="filter-options">
                <label class="filter-option">
                  <input type="radio" name="status-filter" value="all" checked>
                  <span class="filter-label">Tout (${filterStats.total})</span>
                </label>
                <label class="filter-option">
                  <input type="radio" name="status-filter" value="error">
                  <span class="filter-label">Erreurs (${filterStats.errors})</span>
                </label>
                <label class="filter-option">
                  <input type="radio" name="status-filter" value="warning">
                  <span class="filter-label">Warnings (${filterStats.warnings})</span>
                </label>
              </div>
            </div>
            
            <div class="filter-group">
              <div class="filter-title">Règles métier</div>
              <div class="filter-options rules-grid">
                <label class="filter-option">
                  <input type="checkbox" name="rule-filter" value="all" checked>
                  <span class="filter-label">Toutes</span>
                </label>
                ${this.generateRuleFilters(filterStats.rules)}
              </div>
            </div>
          </div>
        </div>
    `;
  }

  /**
   * Générer les filtres de règles
   */
  static generateRuleFilters(rulesStats) {
    const sortedRules = Object.entries(rulesStats).sort(([a], [b]) => a.localeCompare(b));

    return sortedRules
      .map(
        ([rule, count]) => `
      <label class="filter-option">
        <input type="checkbox" name="rule-filter" value="${rule}">
        <span class="filter-label">${rule} (${count})</span>
      </label>
    `
      )
      .join("");
  }

  /**
   * Générer le JavaScript pour les filtres
   */
  static generateFilterJS() {
    return `
      function initializeFilters() {
        // Gérer les filtres de statut
        document.querySelectorAll('input[name="status-filter"]').forEach(radio => {
          radio.addEventListener('change', applyFilters);
        });
        
        // Gérer les filtres de règles
        document.querySelectorAll('input[name="rule-filter"]').forEach(checkbox => {
          checkbox.addEventListener('change', handleRuleFilter);
        });
      }
      
      function handleRuleFilter(event) {
        const isAll = event.target.value === 'all';
        const ruleCheckboxes = document.querySelectorAll('input[name="rule-filter"]:not([value="all"])');
        
        if (isAll && event.target.checked) {
          // Décocher toutes les autres règles
          ruleCheckboxes.forEach(cb => cb.checked = false);
        } else if (!isAll && event.target.checked) {
          // Décocher "Toutes" si une règle spécifique est cochée
          document.querySelector('input[name="rule-filter"][value="all"]').checked = false;
        }
        
        applyFilters();
      }
      
      function applyFilters() {
        const statusFilter = document.querySelector('input[name="status-filter"]:checked').value;
        const ruleFilters = Array.from(document.querySelectorAll('input[name="rule-filter"]:checked'))
          .map(cb => cb.value);
        
        const allFibers = document.querySelectorAll('.fiber-node');
        
        allFibers.forEach(fiber => {
          const shouldShow = shouldShowFiber(fiber, statusFilter, ruleFilters);
          fiber.style.display = shouldShow ? 'block' : 'none';
          
          //Masquer les messages selon le filtre de statut
          if (shouldShow) {
            const messages = fiber.querySelectorAll('.tree-message');
            messages.forEach(message => {
              const messageClass = message.className;
              let showMessage = true;
              
              // Si filtre "Erreurs", masquer les warnings
              if (statusFilter === 'error' && messageClass.includes('warning') && !messageClass.includes('error')) {
                showMessage = false;
              }
              // Si filtre "Warnings", masquer les erreurs
              else if (statusFilter === 'warning' && messageClass.includes('error') && !messageClass.includes('warning')) {
                showMessage = false;
              }
              
              message.style.display = showMessage ? 'block' : 'none';
            });
          }
        });
        
        // Masquer les modules/tiroirs vides
        updateEmptyContainers();
      }
      
      function shouldShowFiber(fiberNode, statusFilter, ruleFilters) {
        const fiberClass = fiberNode.className;
        
        // Filtrer par statut
        if (statusFilter === 'error' && !fiberClass.includes('error')) return false;
        if (statusFilter === 'warning' && !fiberClass.includes('warning')) return false;
        

        // Si aucune règle spécifique n'est cochée, ne rien montrer
        if (ruleFilters.length === 0) return false;
        
        // Si "Toutes" est coché, montrer (le filtre statut a déjà été appliqué)
        if (ruleFilters.includes('all')) return true;
        
        // Vérifier si la fibre a des messages correspondant aux règles filtrées
        const messages = fiberNode.querySelectorAll('.tree-message');
        return Array.from(messages).some(msg => {
          const messageTitle = msg.querySelector('.message-title').textContent;
          return ruleFilters.some(rule => messageTitle.includes(\`[\${rule}]\`));
        });
      }
      
      function updateEmptyContainers() {
        // Gérer les modules
        document.querySelectorAll('.module-node').forEach(module => {
          const visibleFibers = module.querySelectorAll('.fiber-node[style*="block"], .fiber-node:not([style*="none"])');
          module.style.display = visibleFibers.length > 0 ? 'block' : 'none';
        });
        
        // Gérer les tiroirs
        document.querySelectorAll('.tiroir-node').forEach(tiroir => {
          const visibleModules = tiroir.querySelectorAll('.module-node[style*="block"], .module-node:not([style*="none"])');
          tiroir.style.display = visibleModules.length > 0 ? 'block' : 'none';
        });
      }
    `;
  }
}
